<template>
    <div>
        <div class="drawingScreenshotPopupContainer">
            <div>
                <Editor :canvasWidth="editorCanvasWidth" :canvasHeight="editorCanvasHeight" :ref="editorRefName" :editorId="editorRefName" />
            </div>
            <div :style="toolbarStyle">
                <div :style="toolbarStyle2">
                    <div :class="colorChooserClasses['red']" @click="onToolClicked('red')" title="Vörös">&nbsp;</div>
                    <div :class="colorChooserClasses['green']" @click="onToolClicked('green')" title="Zöld">&nbsp;</div>
                    <div :class="colorChooserClasses['blue']" @click="onToolClicked('blue')" title="Kék">&nbsp;</div>
                    <div :class="colorChooserClasses['yellow']" @click="onToolClicked('yellow')" title="Sárga">&nbsp;</div>
                    <div :class="colorChooserClasses['black']" @click="onToolClicked('black')" title="Fekete">&nbsp;</div>
                    <div :class="colorChooserClasses['eraser']" @click="onToolClicked('eraser')" title="Radír"></div>
                    <div class="tool separated dx-icon-undo" @click="onUndoClicked" title="Visszavonás"></div>
                    <div class="tool dx-icon-redo" @click="onRedoClicked" title="Mégis"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from 'vue-image-markup';

    export default {
        name: "ScreenshotEditor",
        components: {
            Editor
        },
        props: {
            edRefName: {
                type: String,
                default: 'scEditor'
            }
        },
        data() {
            return {
                editorCanvasWidth: 100,
                editorCanvasHeight: 100,
                colorChooserClasses: '',
                selectedColor: 'red',
                selectedMode: 'freeDrawing',
                editorRefName: 'scEditor',
                toolbarStyle: 'display: none;',
                toolbarStyle2: '',
            }
        },
        computed: {
        },
        created() {
            this.editorRefName = this.edRefName;
            this.setToolChooserState();
        },
        mounted() {
            this.$root.$emit('get_latest_screenshot', this.onScreenshotArrived);
        },
        methods: {
            setToolChooserState() {
                this.colorChooserClasses = [];
                var commonClasses = 'tool color-chooser';
                for (const color of ['red', 'green', 'black', 'blue', 'yellow', 'eraser']) {
                    this.colorChooserClasses[color] = commonClasses + ' color-chooser-' + color;
                    if (color == 'eraser') {
                        this.colorChooserClasses[color] += ' dx-icon-clearformat';
                    }
                    if (this.selectedColor == color) {
                        this.colorChooserClasses[color] += ' color-chooser-selected';
                    }
                }
            },
            onDrawingScreenshotPopupShowing(e) {
                var content = e.component.content();
                if (!content.classList.contains("drawingScreenshotPopupContent")) {
                    content.classList.add("drawingScreenshotPopupContent");
                }
            },
            setEditorModeAndOptions() {
                switch (this.selectedMode) {
                    case 'freeDrawing':
                        let customizeFreeDrawing = { stroke: this.selectedColor, strokeWidth: "3" };
                        this.getEditor().set('freeDrawing', customizeFreeDrawing);
                        break;
                    case 'eraser':
                        this.getEditor().set('eraser');
                        break;
                }
                
            },
            onUndoClicked() {
                this.getEditor().undo();
                this.setEditorModeAndOptions();
            },
            onRedoClicked() {
                this.getEditor().redo();
                this.setEditorModeAndOptions();
            },
            onToolClicked(color) {
                if (color == 'eraser') {
                    this.selectedMode = 'eraser';
                } else {
                    this.selectedMode = 'freeDrawing';
                }
                this.selectedColor = color;
                this.setToolChooserState();
                this.setEditorModeAndOptions();
            },
            getLatestScreenshot(callbackFunction) {
                callbackFunction(this.latestScreenshotDataUrl);
            },
            onScreenshotArrived(dataUrl) {
                var img = new Image();
                img.onload = () => {
                    let editor = this.getEditor();
                    editor.clear();
                    this.editorCanvasWidth = img.width;
                    this.editorCanvasHeight = img.height;
                    editor.canvas.setDimensions({ width: img.width, height: img.height });
                    editor.setBackgroundImage(dataUrl);
                    var widthRatio = 100;
                    editor.canvas.setDimensions({ width: widthRatio + '%', height: 'auto' }, { cssOnly: true });
                    this.setEditorModeAndOptions();
                    this.setHeight();
                }
                img.src = dataUrl;
            },
            getEditor() {
                return this.$refs[this.editorRefName];
            },
            setHeight() {
                let element = document.getElementById(this.editorRefName);
                let height;
                if (element !== undefined) {
                    height = element.clientHeight;
                }
                this.toolbarStyle = 'display: block; padding-top: ' + (height) + 'px; height: ' + (height + 40) + 'px;';
                this.toolbarStyle2 = 'border-top: 1px solid #ccc; height: 40px;';
            }
        }
    };
</script>

<style scoped lang="scss">
    .drawingScreenshotPopupContainer {
        border: 1px solid #ccc;
        border-collapse: collapse;
    }

    .color-chooser {
        display: block;
        line-height: 24px;
        width: 24px;
        height: 24px;
        border-radius: 3px;
        border: 1px solid #303030;
        opacity: 0.4;
        box-sizing: border-box;
    }

    .color-chooser-eraser {
        
    }

    .color-chooser-red {
        background-color: red;
    }

    .color-chooser-green {
        background-color: green;
    }

    .color-chooser-black {
        background-color: black;
    }

    .color-chooser-blue {
        background-color: blue;
    }

    .color-chooser-yellow {
        background-color: yellow;
    }

    .color-chooser-selected {
        border: 3px solid rgba(255, 255, 255, 0.50);
        opacity: 1;
    }

    .tool {
        display: block;
        font-size: 24px;
        margin: 8px;
        cursor: pointer;
        float: left;
    }

    .custom-editor {
        margin: auto auto auto 0px;
    }

    .custom-editor .canvas-container {
        margin: auto;
    }

    .dx-popup-content {
        text-align: left !important;
    }

    .separated {
        margin-left: 40px;
    }

</style>
